var React = require('react');

function Home (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.5,6.1L8,0L0.5,6.1C0.2,6.4,0,6.8,0,7.2v7.3C0,15.3,0.7,16,1.5,16h3.9v-4c0-1.5,1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7v4h3.9\n\tc0.8,0,1.5-0.7,1.5-1.5V7.2C16,6.8,15.8,6.4,15.5,6.1z","fill":"currentColor"}));
}

Home.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Home;

Home.default = Home;
